import Delegate from '../../models/delegate'
import Vue from 'vue'
import DelegateType from '../../enums/delegate-type'

// import Fuse from 'fuse.js'
export default {
  namespaced: true,
  state: {
    all: [],
    idx: null
  },
  getters: {
    all: state => state.all.map((d) => Delegate.fromJson(d)),
    associations: (state, getters) => getters.all.filter((delegate) => !delegate.realPerson),
    getById: state => (id) => {
      return state.all.filter((delegate) => delegate.id === id)[0]
    },
    search: (state, getters) => (query, type = null) => {
      return getters.all
        .filter((delegate) => {
          if (!type || type === DelegateType.BOTH) {
            return true
          }
          if (type === DelegateType.PERSON) {
            return delegate.realPerson
          }
          if (type === DelegateType.ASSOCIATION) {
            return !delegate.realPerson
          }
          return true
        }).filter((delegate) => {
          if (delegate.realPerson) {
            return delegate.forename.toLowerCase().startsWith(query.toLowerCase()) ||
              delegate.surname.toLowerCase().startsWith(query.toLowerCase())
          }
          return delegate.associationName.toLowerCase().startsWith(query.toLowerCase())
        }).sort((a, b) => {
          if (a.realPerson && !b.realPerson) {
            return -1
          }
          if (!a.realPerson && b.realPerson) {
            return 1
          }
          if (a.realPerson && b.realPerson) {
            return a.surname.localeCompare(b.surname)
          }
          return a.associationName.localeCompare(b.associationName)
        })
    }
  },
  mutations: {
    SET_ALL (state, delegates) {
      state.all = delegates
      /**
      state.idx = new Fuse(delegates, {
        keys: [
          'association_name', // will be assigned a `weight` of 1
          {
            name: 'first_name',
            weight: 2
          },
          {
            name: 'last_name',
            weight: 2
          }
        ]
      })
        **/
    },
    UPDATE (state, delegate) {
      const i = state.all.findIndex((d) => d.id === delegate.id)
      if (i < 0) {
        return
      }
      Vue.set(state.all, i, delegate)
    }
  },
  actions: {
    async load ({commit}) {
      const delegates = await this.$api.getDelegates()
      commit('SET_ALL', delegates)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/delegates.js